import type { SearchSourceType } from '@affine/core/modules/docs-search';
import { LiveData, Service } from '@toeverything/infra';

import { QuickSearch } from '../entities/quick-search';

export class QuickSearchService extends Service {
  readonly personFilter$ = new LiveData<{ id: string; name: string } | null>(
    null
  );
  /**
   * The source kind the search is scoped to (the advanced search's source
   * chip): docs then list and count only their places of that kind.
   */
  readonly placeSource$ = new LiveData<SearchSourceType | null>(null);
  public readonly quickSearch = this.framework.createEntity(QuickSearch);
}
